import { Container } from 'react-bootstrap';

function App() {
    return (
        <Container>
            <div className="welcome-center">
                <div className="welcome-inner">
                    <h5 className='notification'><br/><br/>Welcome</h5>
                </div>
            </div>
        </Container>
    );
}

export default App;
